/**
 * Money for display in the billing UI. `null` formats as `$0.00` so an empty field reads as
 * a zero rather than blowing up a template string.
 */
export const formatUsd = (usd: number | null): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
  }).format(usd ?? 0);
